export default "__VITE_ASSET__CfQAs$V___"